import React, { useContext, useMemo } from 'react';
//mui imports ======
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import useStyles from './styles';
import { Typography } from '@mui/material';
//=================

import { UserContext } from '../../Contexts/UserContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../core/constants';
import InfoButton from '../InfoButton';
const { SYSTEMS, UI_ACCESS, TYPES } = ACCESS_CONTROL_CONSTANTS;

const SwitchInput = ({
	keyData,
	label,
	object,
	updateObject,
	disabled,
	defaultChecked = false,
	showInfoButton = false,
	infoMessage = '',
	infoButtonProps = {},
	isMandatory = false,
	containerStyles,
	isObjectEditor = true,
	directValue,
	updateDirectValue,
	system = SYSTEMS.FRAMERATE
}) => {
	const classes = useStyles();
	const { getAccessControlSet } = useContext(UserContext);

	const getValue = () => {
		if (isObjectEditor) {
			if (keyData in object) return !!object[keyData];
			return !!defaultChecked;
		}
		return !!directValue;
	};

	const getLabel = () => {
		return isMandatory ? `${label} *` : label;
	};

	const handleChange = (e) => {
		if (isObjectEditor) {
			updateObject((obj) => {
				const deepClonedObj = structuredClone(obj);
				return { ...deepClonedObj, [keyData]: e.target.checked };
			});
		} else {
			updateDirectValue(e.target.checked);
		}
	};

	/**
	 * This variable contains a set of strings that signifies if this input is either visible/disabled/hidden
	 * @type {Set<string>}
	 */
	const switchInputControlledAccessSet = useMemo(() => {
		return getAccessControlSet(system, TYPES.INPUT_NAMES, keyData);
	}, [getAccessControlSet, keyData, system]);

	return (
		<>
			{!switchInputControlledAccessSet.has(UI_ACCESS.HIDE) && (
				<FormGroup className={classes.switchInput} style={containerStyles || {}}>
					<FormControlLabel
						control={
							<Switch
								size="large"
								disabled={disabled || switchInputControlledAccessSet.has(UI_ACCESS.DISABLE)}
								checked={getValue()}
								onChange={handleChange}
							/>
						}
						label={
							<Typography
								className={classes.switchInputTypography}
								color="primary.grey"
								fontWeight={600}
								variant="h6"
							>
								{getLabel()}
								{showInfoButton && getLabel()?.trim() && (
									<InfoButton message={infoMessage} {...infoButtonProps} />
								)}
							</Typography>
						}
					/>
				</FormGroup>
			)}
		</>
	);
};
export default SwitchInput;
